import styled from '@emotion/styled';
import { Link } from 'react-router-dom';
import COLORS from '$variables/colors';
import { typography, spacing } from '$variables/theme';

export const Header = styled.div`
  padding: 40px ${spacing.xLarge} ${spacing.xLarge};
  border-bottom: 1px solid ${COLORS.grey};
`;

export const Content = styled.div`
  padding: ${spacing.xLarge};
`;

export const Subtitle = styled.div`
  width: 100%;
  font-size: 14px;
  font-weight: ${typography.fontWeightMedium};
  color: ${COLORS.olive};
`;

export const SelectorContainer = styled.div`
  margin-top: ${spacing.small};
  width: 100%;
`;

export const Message = styled.div`
  color: ${COLORS.shadow5};
  text-align: center;
`;

export const MessageLink = styled(Link)`
  color: ${COLORS.purple};
`;
